import { use } from 'react';
import AuthContext, { type FirebaseAuthContextValue } from 'contexts/FirebaseContext';

// ==============================|| AUTH HOOKS ||============================== //

export default function useAuth(): FirebaseAuthContextValue {
  const context = use(AuthContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
}
